import apiClient from "../apiClient";

export const getUserById = async (id) => {
  try {
    const response = await apiClient.get(`/users/getUserById/${id}`);
    // console.log("User by id", response?.data);

    return response?.data?.user;
  } catch (error) {
    // console.log("erro user by id", error);

    throw error;
  }
};

export const getAllUsers = async () => {
  try {
    const response = await apiClient.get("users/getAllUsers");
    // console.log("Respuesta get all users", response?.data?.data);
    return response?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};

export const gettAllSpecialist = async () => {
  try {
    const response = await apiClient.get("proffessionals/getAll-sp");
    return response?.data?.data?.providers ?? [];
  } catch (error) {
    throw error;
  }
};

export const loginAuth = async (userData) => {
  try {
    const response = await apiClient.post("login/login-management", userData);

    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await apiClient.post("users/newUser", userData);
    // console.log(response);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const registerSpecialis = async (userData) => {
  try {
    const response = await apiClient.post("proffessionals/create-sp", userData);
    // console.log(response);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const deactivateAccount = async (id) => {
  try {
    const response = await apiClient.put(`users/deactivateUser/${id}`);
    // console.log(response);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const activateAccount = async (id) => {
  try {
    const response = await apiClient.put(`users/reactive-user`, {userId:id});
    // console.log(response);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

